import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=03e8d672&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03e8d672')) {
      api.createRecord('03e8d672', component.options)
    } else {
      api.reload('03e8d672', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=03e8d672&", function () {
      api.rerender('03e8d672', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Amrg0iQ1HBnw/JS/offershelp.vue"
export default component.exports